import { useTranslation } from "react-i18next";
import { Send2 } from "iconsax-react";
import { Button } from "@/shared/ui";

interface Props {
  onOpenInvite: () => void;
}

export default function HiringHeader({ onOpenInvite }: Props) {
  const { t } = useTranslation("HiringPage");

  return (
    <div className="flex items-center justify-between pt-1 pb-4 border-b surface-base-stroke mb-5">
      <h1 className="text-display-xs content-base-primary">{t("header.title")}</h1>
      <Button variant="primary" size="huge" onClick={onOpenInvite}>
        <Send2 size={16} color="currentColor" />
        {t("header.newInvitation")}
      </Button>
    </div>
  );
}
